import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Link } from 'react-router-dom';
import UserName from 'components/UserName/UserName';
import AppNavMenu from './AppNavMenu';
import OutsideClick from 'components/OutsideClick/OutsideClick';
import ModuleSearch from 'components/FormControl/ModuleSearch/ModuleSearch';
import { toggleAppNavMenu, hideAppNavMenu } from 'redux/modules/appnavmenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cloudImageCrop } from 'utils/helpers';
import { ROUTE_PATHS } from 'config/constants';
import './app-nav.css';

const NAV_USER = [
    {
        id: 1,
        isMobile: true,
        label: 'Fil d\'actualité',
        image: require('assets/icons/home-b.svg'),
        imageActive: require('assets/icons/home-g.svg'),
        route: ROUTE_PATHS.NEWSFEED,
        isCounter: false
    }, {
        id: 2,
        isMobile: true,
        label: 'Campagnes',
        image: require('assets/icons/megaphone-b.svg'),
        imageActive: require('assets/icons/megaphone-g.svg'),
        route: ROUTE_PATHS.CAMPAIGNS,
        isCounter: false
    }, {
        id: 3,
        isMobile: false,
        label: 'Communautés',
        image: require('assets/icons/community-b.svg'),
        imageActive: require('assets/icons/community-g.svg'),
        route: ROUTE_PATHS.FACTIOS,
        isCounter: false
    }, {
        id: 4,
        isMobile: true,
        label: 'Notifications',
        image: require('assets/icons/bell-b.svg'),
        imageActive: require('assets/icons/bell-g.svg'),
        route: ROUTE_PATHS.NOTIFICATIONS,
        isCounter: true
    }
];

const NAV_ORG = [
    {
        id: 1,
        isMobile: true,
        label: 'Suivi de campagnes',
        image: require('assets/icons/dashboard-b.svg'),
        imageActive: require('assets/icons/dashboard-g.svg'),
        route: ROUTE_PATHS.DASHBOARD_ORG_SUPPORT,
        isCounter: false
    }, {
        id: 2,
        isMobile: true,
        label: 'Campagnes',
        image: require('assets/icons/megaphone-b.svg'),
        imageActive: require('assets/icons/megaphone-g.svg'),
        route: ROUTE_PATHS.CAMPAIGNS,
        isCounter: false
    }, {
        id: 3,
        isMobile: false,
        label: 'Communautés',
        image: require('assets/icons/community-b.svg'),
        imageActive: require('assets/icons/community-g.svg'),
        route: ROUTE_PATHS.FACTIOS,
        isCounter: false
    }, {
        id: 4,
        isMobile: true,
        label: 'Notifications',
        image: require('assets/icons/bell-b.svg'),
        imageActive: require('assets/icons/bell-g.svg'),
        route: ROUTE_PATHS.NOTIFICATIONS,
        isCounter: true
    }
];

const NAV_REP = [
    {
        id: 1,
        isMobile: true,
        label: 'Tableau de bord',
        icon: 'chart-line',
        route: ROUTE_PATHS.DASHBOARD_REP_CAMPAIGNS,
        isCounter: false
    }, {
        id: 2,
        isMobile: true,
        label: 'Campagnes',
        image: require('assets/icons/megaphone-b.svg'),
        imageActive: require('assets/icons/megaphone-g.svg'),
        route: ROUTE_PATHS.CAMPAIGNS,
        isCounter: false
    }, {
        id: 3,
        isMobile: true,
        label: 'Communautés',
        image: require('assets/icons/community-b.svg'),
        imageActive: require('assets/icons/community-g.svg'),
        route: ROUTE_PATHS.FACTIOS,
        isCounter: false
    }
];

class AppNav extends PureComponent {
    static propTypes = {
        location: PropTypes.object.isRequired,
        toggleAppNavMenu: PropTypes.func.isRequired,
        hideAppNavMenu: PropTypes.func.isRequired,
        unreadNotifications: PropTypes.number.isRequired,
        isAuthed: PropTypes.bool.isRequired,
        avatar: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        isRep: PropTypes.bool,
        isOrg: PropTypes.bool
    }

    constructor(props) {
        super(props);

        const { isOrg, isRep } = props;

        if (isOrg) {
            this.NAV_ITEMS = NAV_ORG;
        }
        else if (isRep) {
            this.NAV_ITEMS = NAV_REP;
        }
        else {
            this.NAV_ITEMS = NAV_USER;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.props.hideAppNavMenu();
        }
    }

    renderNavItem = (item) => {
        const isActive = item.route === this.props.location.pathname;
        const mobileHideClassName = !item.isMobile ? 'AppNav__navitem--hidemobile' : '';

        return (
            <Link
                key={item.id}
                className={`AppNav__navitem ${mobileHideClassName} ${isActive ? 'AppNav__navitem--active' : ''}`}
                to={item.route}>
                <div className='AppNav__navitem-iconcontainer'>
                    {item.icon
                        ? <FontAwesomeIcon
                            className='AppNav__navitem-icon'
                            icon={item.icon} />
                        : <img
                            className='AppNav__navitem-icon'
                            src={isActive ? item.imageActive : item.image}
                            alt='' />
                    }

                    {!!(item.isCounter && this.props.unreadNotifications) && (
                        <div className='AppNav__navitem-counter'>
                            {this.props.unreadNotifications}
                        </div>
                    )}
                </div>

                <span className='AppNav__navitem-label'>
                    {item.label}
                </span>
            </Link>
        );
    }

    render() {
        const {
            isAuthed, isRep, avatar, firstName, lastName,
            toggleAppNavMenu, hideAppNavMenu, unreadNotifications
        } = this.props;

        return (
            <div className='AppNav'>
                <div className='AppNav__logo'>
                    <Link to={ROUTE_PATHS.NEWSFEED}>
                        <img
                            className='AppNav__logo-image'
                            src={require('assets/logo.svg')}
                            alt='FACTIO' />
                    </Link>
                </div>

                <div className='AppNav__search'>
                    <ModuleSearch
                        className='AppNav__search-ModuleSearch' />
                </div>

                <div className='AppNav__nav'>
                    {this.NAV_ITEMS.map(this.renderNavItem)}
                </div>

                {isAuthed
                    ? <OutsideClick
                        className='AppNav__profilewrapper'
                        onOutsideClick={hideAppNavMenu}>
                        <div className='AppNav__profile' onClick={toggleAppNavMenu}>
                            <div className='AppNav__profile-avatarcontainer'>
                                {avatar
                                    ? <img
                                        className='AppNav__profile-avatar'
                                        src={avatar}
                                        alt='Avatar' />
                                    : <FontAwesomeIcon
                                        className='AppNav__profile-avatar'
                                        icon='user-circle' />
                                }

                                {!!(isRep && unreadNotifications) && (
                                    <div className='AppNav__profile-counter'>
                                        {unreadNotifications}
                                    </div>
                                )}

                                <div className='AppNav__profile-menu'>
                                    <FontAwesomeIcon icon='bars' />
                                </div>
                            </div>

                            <UserName
                                className='AppNav__profile-name'
                                firstName={firstName}
                                lastName={lastName} />
                        </div>

                        <AppNavMenu />
                    </OutsideClick>
                    : <div className='AppNav__profilewrapper' />
                }
            </div>
        );
    }
}

function mapStateToProps({ authentication }) {
    const { profileData } = authentication;
    const avatar = profileData.avatar ? cloudImageCrop(profileData.avatar, 37) : null;

    return {
        unreadNotifications: authentication.unreadNotifications,
        isAuthed: authentication.isAuthed,
        avatar: avatar,
        firstName: profileData.first_name,
        lastName: profileData.last_name,
        isOrg: !!profileData.is_organization,
        isRep: authentication.isRep
    };
}

function mapDispatchToProps(dispatch) {
    return {
        toggleAppNavMenu: () => {
            dispatch(toggleAppNavMenu());
        },
        hideAppNavMenu: () => {
            dispatch(hideAppNavMenu());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppNav);
